// Geteilte UI-Label-Hooks für Backend-Enums (Session-Kind, Modalität,
// AT-Format, TLA-Phase). Die ENUM-Werte kommen aus dem Backend, die LABELS
// sind UI-seitig definiert → i18n-Keys statt hardcodierter deutscher Maps.
// (Methoden-/Typ-Labels aus dem Katalog, z. B. tla_types.json, bleiben
// bewusst unangetastet — die liefert das Backend.)

import { useTranslation } from "react-i18next";

import type { SessionKind, TLAPhase } from "@/api/client";

// Datums-Locale passend zur UI-Sprache (de-DE / en-GB).
export function useDateLocale(): string {
  const { i18n } = useTranslation();
  return i18n.language.startsWith("en") ? "en-GB" : "de-DE";
}

export function useModalityLabels(): Record<string, string> {
  const { t } = useTranslation();
  return {
    presence: t("labels.modality.presence"),
    synchronous: t("labels.modality.synchronous"),
    asynchronous: t("labels.modality.asynchronous"),
    blended: t("labels.modality.blended"),
  };
}

export function useAtFormatLabels(): Record<string, string> {
  const { t } = useTranslation();
  return {
    closed: t("labels.atFormat.closed"),
    semi_open: t("labels.atFormat.semi_open"),
    open: t("labels.atFormat.open"),
  };
}

export function useSessionKindLabels(): Record<SessionKind, string> {
  const { t } = useTranslation();
  return {
    presence_day: t("labels.sessionKind.presence_day"),
    online: t("labels.sessionKind.online"),
    coaching: t("labels.sessionKind.coaching"),
    group_meeting: t("labels.sessionKind.group_meeting"),
    wol_cycle: t("labels.sessionKind.wol_cycle"),
    exam: t("labels.sessionKind.exam"),
    custom: t("labels.sessionKind.custom"),
  };
}

export interface PhaseOption {
  value: TLAPhase;
  label: string;
}

export function usePhaseOptions(): PhaseOption[] {
  const { t } = useTranslation();
  return [
    { value: "pre", label: t("labels.phase.pre") },
    { value: "in", label: t("labels.phase.in") },
    { value: "between", label: t("labels.phase.between") },
    { value: "post", label: t("labels.phase.post") },
  ];
}
